import React from 'react'

const PhoneIcon = ({ className, size = 24, color = 'currentColor' }) => {
  return (
    <svg 
      className={className}
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="phone-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="rgba(100, 200, 150, 1)" />
          <stop offset="100%" stopColor="rgba(100, 150, 255, 1)" />
        </linearGradient>
        <filter id="phone-glow">
          <feGaussianBlur stdDeviation="2" result="coloredBlur"/>
          <feMerge>
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>
      <path 
        d="M22 16.92V19.92C22 20.51 21.54 21 20.95 21C10.03 20.23 3.77 13.97 3 3.05C2.96 2.46 3.45 2 4.05 2H7.05C7.59 2 8.04 2.41 8.09 2.95C8.18 3.93 8.38 4.88 8.68 5.79C8.81 6.18 8.69 6.62 8.4 6.9L6.63 8.67C7.93 11.27 10.73 14.07 13.33 15.37L15.1 13.6C15.39 13.31 15.82 13.19 16.21 13.32C17.12 13.62 18.07 13.82 19.05 13.91C19.59 13.96 20 14.41 20 14.95V17.92C20 18.25 19.89 18.56 19.68 18.78C19.47 18.99 19.18 19.11 18.87 19.11L20.95 21C21.54 21 22 20.51 22 19.92V16.92Z" 
        stroke="url(#phone-gradient)" 
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round"
        filter="url(#phone-glow)"
      />
      <path 
        d="M15 5C15.93 5.32 16.77 5.84 17.46 6.54C18.16 7.23 18.68 8.07 19 9" 
        stroke="url(#phone-gradient)" 
        strokeWidth="2" 
        strokeLinecap="round" 
        opacity="0.6"
      />
      <circle cx="18" cy="6" r="1" fill="url(#phone-gradient)" opacity="0.8" />
    </svg>
  )
}

export default PhoneIcon
